import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ArrowDownIcon } from 'icons/arrow-down';
import React from 'react';

import { Skeleton } from './skeleton';

export interface DropdownProps {
  label: string;
  type: string;
  value: string;
  options: ReadonlyArray<{ key: string; label: string }>;
  onSelect: (type: string, option: { key: string; label: string }) => void;
}

export function Dropdown({
  label,
  value,
  options,
  type,
  onSelect,
}: DropdownProps) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="flex h-8 w-full items-center gap-2 rounded-3xl bg-gray-100 px-3 py-2 outline-none md:w-fit">
        <p className="text-14 leading-4">
          {label}: <b>{value}</b>
        </p>
        <ArrowDownIcon />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          sideOffset={5}
          className="z-1000 max-h-[500px] min-w-[240px] cursor-default overflow-auto border border-solid border-gray-100 bg-white py-2 shadow-md"
        >
          {options.map(option => (
            <DropdownMenu.Item
              key={option.key}
              className="text-14 focus:bg-primary-50 select-all px-4 py-3 leading-4 outline-none"
              onSelect={() => onSelect(type, option)}
            >
              {option.label}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}

Dropdown.Skeleton = function DropdownSkeleton() {
  return <Skeleton className="h-[32px] w-full !rounded-3xl md:w-[150px]" />;
};
